import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SearchParams } from "src/app/shared/model/searchParams";
import { UrlUtilService } from "src/app/shared/service/url-util/url-util.service";
import { endpoints } from "src/environments/environment";
import { InvoiceArchiveFilters } from "../components/invoice-archive/model/invoiceArchiveFilters.model";
import { ForwardingInvoice } from "../components/invoice-reception-mode/model/forwardingInvoice";
import { InvoiceReceiptFilters } from "../components/invoice-reception-mode/model/invoiceReceiptFilters.model";
import { InvoiceArchiveSelectExportRequest } from "../components/invoice-archive/model/invoiceArchiveSelectExportRequest.model";
import { PaypalPayload, PaypalPayment } from "../model/paypalPayment";
import { DocumentBatch } from "../components/documents-archive/model/archive-document.model";
import { PaymentFilters } from "../components/online-payment/model/online-payment.model";
import { TrasactionRequest, UpdateTransaction } from "../model/onlinePyment";
import { CustomerRequestExport, CustomersRequest } from "src/app/shared/components/dialog/components/customer-choose/model/cs.model";
import { ApiSearchUtilService } from "src/app/shared/service/api-search-util/api-search-util.service";

@Injectable({
  providedIn: "root",
})
export class AdministrationService {
  private ADMINISTRATION_INVOICE_ARCHIVE =
    endpoints.administration_invoice_archive;
  private ADMINISTRATION_INVOICE_ARCHIVE_OLSA =
    endpoints.administration_invoice_archive_olsa;
  private ADMINISTRATION_INVOICE_ARCHIVE_OLSA_EXPORT =
    endpoints.administration_invoice_archive_olsa_export;
  private ADMINISTRATION_INVOICE_ARCHIVE_EXPORT =
    endpoints.administration_invoice_archive_export;
  private ADMINISTRATION_INVOICE_ARCHIVE_EXPORT_SELECTED =
    endpoints.administration_invoice_archive_export_selected;
  private INVOICES_RECEIPT = endpoints.invoices_receipt;
  private INVOICES_RECEIPT_EXPORT = endpoints.invoices_receipt_export;
  private DETAIL_INVOICE_RECEIPT = endpoints.detail_invoice_receipt;
  private FORWARDING_INVOICE = endpoints.forwarding_invoice;
  private ONLINE_PAYMENT = endpoints.online_payment;

  private ARCHIVE_DOCUMENT = endpoints.archive_document;
  private DOCUMENT = endpoints.document;
  private DOWNLOAD_DOCUMENT_ZIP = endpoints.download_document_zip;

  private CREDIT_CARD_SERVICE_LIST = endpoints.credit_card_service_list;
  // TODO Da rimuovere dopo aver integrato il servizio di BE per colonne e filtri
  private CREDIT_CARD_PP = endpoints.inizialize_billingagreement;
  private CREATE_BILLINGAGREEMENT = endpoints.create_billingagreement;
  private PAYPAL_PAYMENT = endpoints.paypal_payment;
  private MYBANK_PAYMENT = endpoints.mybank_payment;
  private DOCUMENT_TYPES = endpoints.document_types;
  private DOWNLOAD_DOCUMENT_DETAIL = endpoints.document_detail;
  private DOWNLOAD_PAGAONLINE_INVOICE = endpoints.pagaonline_download_invoice;
  private ADMINISTRATION_INVOICE_ARCHIVE_DOWNLOAD_ZIP = endpoints.administration_invoice_archive_download_zip;
  private TRANSACTION_ADD = endpoints.add_transaction;
  private UPDATE_TRANSACTION = endpoints.update_transaction;
  private CUSTOMER_LIST_EXPORT = endpoints.customers_list_export;
  private ESITO_PAGAMENTO=endpoints.esito_pagamento;


  constructor(private http: HttpClient, private urlService: UrlUtilService, private apiSearchUtil: ApiSearchUtilService,) { }

  private getBlobHeader(): HttpHeaders {
    return new HttpHeaders({
      "Content-Type": "application/json",
      responseType: "blob",
    });
  }

  getDocumentTypes(): Observable<any> {
    return this.http.get(this.DOCUMENT_TYPES);
  }
  getDocumentsArchive(searchParams: SearchParams, archiveDocumentFilter: any): Observable<any> {
    return this.http.post(
      `${this.ARCHIVE_DOCUMENT}?${this.urlService.convertObjectToSearchParam(
        searchParams
      )}`,
      archiveDocumentFilter,
    );
  }

  downloadDocument(archiveId: string, objectID: string, batchID: string): Observable<any> {
    const headers = this.getBlobHeader();
    return this.http.get<Array<any>>(
      `${this.DOCUMENT}?archiveId=${archiveId}&objectID=${objectID}&batchID=${batchID}`,
      { headers, responseType: "blob" as "json" }
    );
  }

  downloadInvoice(documentId: string): Observable<any> {
    const headers = this.getBlobHeader();
    return this.http.get<Array<any>>(
      `${this.DOWNLOAD_DOCUMENT_DETAIL}/${documentId}`,
      { headers, responseType: "blob" as "json" }
    );
  }

  downloadActiveInvoice(customerId, invoiceDate, invoiceNumber) : Observable<any> {
    const headers = this.getBlobHeader();
    return this.http.post<Array<any>>(
      `${this.DOWNLOAD_PAGAONLINE_INVOICE}`,
      { 
        customerId: customerId,
        invoiceId: invoiceNumber,
        invoiceDate: invoiceDate
       },
      { headers, responseType: "blob" as "json" }
    );
  }

  downloadDocumentAsZip(archiveId: string, objectsID: Array<DocumentBatch>): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      responseType: "blob",
    });
    return this.http.post<Array<any>>(
      `${this.DOWNLOAD_DOCUMENT_ZIP}?archiveId=${archiveId}`,
      { documents: objectsID },
      { headers, responseType: "blob" as "json" }
    );
  }

  getPayments(searchParams: SearchParams, appliedFilters: PaymentFilters) {
    const path = `${this.ONLINE_PAYMENT}?${this.urlService.convertObjectToSearchParam(searchParams)}`;
    return this.http.post(path, appliedFilters);
  }

  getInvoiceArchive(searchParams?: SearchParams, invoiceFilter?): Observable<any> {
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      {
        invoiceFilter,
      }
    );
  }

  getInvoiceArchiveExport(
    searchParams: SearchParams,
    invoiceFilter?: InvoiceArchiveFilters
  ): Observable<any> {
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE_EXPORT
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      { invoiceFilter },
      { responseType: "blob" as "json" }
    );
  }

  getInvoiceArchiveSelectedExport(
    invoiceArchiveSelectedRequest: InvoiceArchiveSelectExportRequest
  ): Observable<any> {
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE_EXPORT_SELECTED}`,
      invoiceArchiveSelectedRequest,
      { responseType: "blob" as "json" }
    );
  }

  getSelectedDownloadZipArchive(
    documentsId
  ): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      responseType: "blob",
    });
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE_DOWNLOAD_ZIP}`,
      documentsId,
      { headers, responseType: "blob" as "json" }
    );
  }

  getInvoiceReceipt(searchParams?: SearchParams, invoiceReceiptFilter?): Observable<any> {
    return this.http.post(
      `${this.INVOICES_RECEIPT}?${this.urlService.convertObjectToSearchParam(
        searchParams
      )}`,
      {
        invoiceReceiptFilter,
      }
    );
  }

  getInvoiceReceiptExport(
    searchParams: SearchParams,
    invoiceReceiptFilter?: InvoiceReceiptFilters
  ): Observable<any> {
    return this.http.post(
      `${this.INVOICES_RECEIPT_EXPORT
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      { invoiceReceiptFilter },
      { responseType: "blob" as "json" }
    );
  }

  getDetailInvoiceReceipt(params: object): Observable<any> {
    return this.http.post(
      `${this.DETAIL_INVOICE_RECEIPT
      }?${this.urlService.convertObjectToSearchParam(params)}`,
      {}
    );
  }

  forwardingInvoice(forwardingInvoice: ForwardingInvoice): Observable<any> {
    return this.http.post(`${this.FORWARDING_INVOICE}`, forwardingInvoice);
  }

  getCreditCardServiceList(searchParams: SearchParams, creditCardServiceFilters?: any): Observable<any> {
    return this.http.get(`${this.CREDIT_CARD_SERVICE_LIST}?${this.urlService.convertObjectToSearchParam(
      searchParams
    )}`,
    creditCardServiceFilters // farla post
    );
  }

  paypalPayment(paypalPayment: PaypalPayload): Observable<any> {
    return this.http.post(this.PAYPAL_PAYMENT, paypalPayment);
  }

  mybankPayment(mybankRequest): Observable<any> {
    return this.http.post(this.MYBANK_PAYMENT, mybankRequest);
  }

  addTransaction(body: TrasactionRequest): Observable<any> {
    return this.http.post(this.TRANSACTION_ADD, body);
  }

  updateTransaction(body: UpdateTransaction): Observable<any> {
    return this.http.post(this.UPDATE_TRANSACTION, body);
  }

  inizializeBillingAgreement(paymentProvider, body, customersId) {
    return this.http.post(`${this.CREDIT_CARD_PP}?paymentProvider=${paymentProvider}&customersId=${customersId}`, body);
  }

  createBillingAgreement(token, payerId) {
    return this.http.get(`${this. CREATE_BILLINGAGREEMENT}/${token}?payerId=${payerId}`);
  }


  comunicaEsito(body:any){
      return this.http.post(this.ESITO_PAGAMENTO,body);
  }

  // getCustomersListExport(
  //   searchParams: SearchParams,
  //   filters?: any
  // ) {
  //   return this.http.post(
  //     `${
  //       this.CUSTOMER_LIST_EXPORT
  //     }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
  //     this.urlService.getBodyWithCustomerRefs({
  //       searchParams,
  //       searchGuid: filters.searchGuid,

  //     }),
  //     { responseType: "blob" as "json" }
  //   );

  // }

  // getCustomersListExport(
  //   searchParams: SearchParams,
  //   filters?: any
  // ) {
  //   return this.http.post(
  //     `${
  //       this.CUSTOMER_LIST_EXPORT
  //     }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
  //     {
  //       searchParams,
  //       searchGuid: filters.searchGuid,
  //     },
  //     { responseType: "blob" as "json" }
  //   );

  // }

  getCustomersListExport(
    searchParams: SearchParams,
    //filters?: any,
    body: CustomerRequestExport,
  ) {
    return this.http.post(
      `${
        this.CUSTOMER_LIST_EXPORT
      }?${this.urlService.convertObjectToSearchParam(searchParams)}`,
      body,
      { responseType: "blob" as "json",
        headers: this.urlService.getDefaultHeaders()
      }
    );

  }

  getInvoiceArchiveOlsa(body?): Observable<any> {
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE_OLSA}`,
      body
    );
  }

  getInvoiceArchiveOlsaExcel(body?): Observable<any> {
    return this.http.post(
      `${this.ADMINISTRATION_INVOICE_ARCHIVE_OLSA_EXPORT}`,
      body,
      { responseType: "blob" as "json",
        headers: this.urlService.getDefaultHeaders()
      }
    );
  }

  getTenant(): string {
    const basePath = window.location.hostname;
    switch (basePath) {
      case this.apiSearchUtil.findTerm(basePath, "fordfleetmanagement"):
        return "fordfm.it";
      case this.apiSearchUtil.findTerm(basePath, "ford"):
        return "ford.it";
      case this.apiSearchUtil.findTerm(basePath, "honda"):
        return "honda.it";
      case this.apiSearchUtil.findTerm(basePath, "suzuki"):
        return "suzuki.it";
      case this.apiSearchUtil.findTerm(basePath, "landrover"):
        return "landrover.it";
      case this.apiSearchUtil.findTerm(basePath, "jaguar"):
        return "jaguar.it";
      case this.apiSearchUtil.findTerm(basePath, "lynkco"):
          return "lynkco.it";
      case this.apiSearchUtil.findTerm(basePath, "smart"):
            return "smart.it";
      case this.apiSearchUtil.findTerm(basePath, "omodajaecoo"):
            return "omodajaecoo.it";
      case this.apiSearchUtil.findTerm(basePath, "mg"):
            return "mg.it";
      default:
        return "ald.it";
    }
  }

}
